import React, { createContext, useContext, lazy, Suspense } from 'react';
import { t } from './i18n';
const anonymous = { currentUser:null, userProfile:null, isAdmin:false, loading:false, error:'', emailVerified:false };
export const AuthContext = createContext(anonymous);
export const useAuth = () => useContext(AuthContext);
const Provider = lazy(() => import('./VrAuthProvider'));
export function AuthProvider({children}) {
  return <Suspense fallback={<p role="status">{t('Cargando cuenta…')}</p>}><Provider>{children}</Provider></Suspense>;
}
